import React, { useState } from "react"
import PropTypes from "prop-types"
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap"
import { subjectsPropTypes } from "../../utils/propTypes"
import "./DeleteModal.scss"

const DeleteModal = (props) => {
  const [modal, setModal] = useState(props.modalOpen)

  const closeButton = (
    <button
      className="close-button fa fa-times"
      type="button"
      title="button"
      onClick={() => setModal(!modal)}
    />
  )

  return (
    <div className="DeleteModal">
      <button
        className="delete-modal-button"
        disabled={props.disabled}
        onClick={(e) => {
          e.stopPropagation()
          setModal(!modal)
        }}
      >
        Delete
      </button>
      <Modal isOpen={modal} className={"delete-modal"}>
        <ModalHeader close={closeButton}>Are You Sure?</ModalHeader>
        <ModalBody>
          <div className="delete-modal-body">
            <div className="explanation">
              <p>
                If you are sure you'd like to delete this case, click "Delete".
                Once deleted you will no longer be able to access this case from
                the archives. SwipeSense is unable to recover deleted cases.
              </p>

              {props.archiveCase && (
                <p>If you'd prefer to archive the case click "Archive."</p>
              )}
            </div>
            <div className="button-row">
              <div className="cancel-text" onClick={() => setModal(!modal)}>
                Cancel
              </div>
              {props.archiveCase && (
                <Button
                  color="primary"
                  className="archive-button"
                  onClick={() => {
                    setModal(!modal)
                    props.onArchive({
                      id: props.id,
                      archive: props.archiveCase,
                      facilityId: props.facilityId,
                      type: props.type,
                      subjects: props.subjects,
                    })
                  }}
                >
                  Archive
                </Button>
              )}
              <Button
                color="primary"
                className="delete-button"
                onClick={() => {
                  setModal(!modal)
                  props.onDelete({
                    id: props.id,
                    type: props.type,
                    facilityId: props.facilityId,
                    subjects: props.subjects,
                    deleted: true,
                  })
                }}
              >
                Delete
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

DeleteModal.propTypes = {
  archiveCase: PropTypes.bool,
  id: PropTypes.string,
  facilityId: PropTypes.string,
  loading: PropTypes.bool,
  modalOpen: PropTypes.bool,
  onArchive: PropTypes.func,
  onDelete: PropTypes.func,
  type: PropTypes.string,
  subjects: subjectsPropTypes,
  disabled: PropTypes.bool,
}

DeleteModal.defaultProps = {
  archiveCase: true,
  modalOpen: false,
  disabled: false,
}

export default DeleteModal
